import { lensPath, view } from 'ramda';
import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators';

import ACCOUNT_ACTION_TYPES, {
  BankDetailsActionType,
  WithdrawalActionTypeIndia,
  WithdrawalHistoryActionType,
} from 'actionTypes/account';
import { OFFRAMP_ACTION_TYPES } from 'actionTypes/offramp';
import { addLogsToSentry } from 'helpers/sentry';

const withdrawlActions = [
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.GET_BANK_ACCOUNTS].FAIL,
  ACCOUNT_ACTION_TYPES[WithdrawalActionTypeIndia.NEW_WITHDRAWAL].FAIL,
  ACCOUNT_ACTION_TYPES[WithdrawalActionTypeIndia.WITHDRAWAL_CODE_VERIFICATION].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.GET_BANK_DETAILS].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.DELETE_BANK_ACCOUNT].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.ADD_ACCOUNT_CHECK_STATUS].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.ADD_ACCOUNT_SEND_OTP].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.ADD_ACCOUNT_VERIFY_OTP].FAIL,
  ACCOUNT_ACTION_TYPES[BankDetailsActionType.ADD_ACCOUNT_RESEND_OTP].FAIL,
  ACCOUNT_ACTION_TYPES[WithdrawalHistoryActionType.FETCH_DATA].FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_FIAT_WITHDRAWAL_CONFIRMATION_CODE.FAIL,
  OFFRAMP_ACTION_TYPES.SUBMIT_FIAT_WITHDRAWAL_CREATE.FAIL,
];
const bodyLens = data => view(lensPath(['error', 'response', 'body', 'error']), data);

const withdrawlErrorLogginEpic = (action$, state$) =>
  action$.pipe(
    ofType(...withdrawlActions),
    map(action => {
      const userId = state$.value.user.id!;
      const email = state$.value.user.email!;
      const error = bodyLens(action);
      addLogsToSentry(
        { id: userId, email, error },
        `Withdrawal Error - ${error?.code} - ${action?.type!}`
      );
    })
  );

export default withdrawlErrorLogginEpic;
